import { ApiResponse } from '@marketplace-web/core-api/api-client-util'

import { api } from '@marketplace-web/core-api/core-api-client-util'

import {
  SaveShippingOrderContactArgs,
  ShippingContactConfigurationResp,
} from '../types/shipping-contact'

export const getShippingContactConfiguration = () =>
  api.get<ShippingContactConfigurationResp>('/configurations/shipping_contact')

export const saveShippingOrderContact = (args: SaveShippingOrderContactArgs) =>
  api.post<ApiResponse>(`/shipping_orders/${args.shippingOrderId}/shipping_contact`, {
    save_for_later: args.saveForLater,
    receiver_phone_number: args.receiverPhoneNumber,
    sender_phone_number: args.senderPhoneNumber,
    phone_number: args.phoneNumber,
  })

export const deleteShippingOrderContact = (shippingOrderId: string) =>
  api.delete<ApiResponse>(`/shipping_orders/${shippingOrderId}/shipping_contact`)
